<template>
  <div>
    <collapse-group title="Text">

      <el-form :model="textForm" @submit.native.prevent label-width="90px" label-position="left">
        <el-form-item label="Text">
          <el-input v-model="textForm.text" autocomplete="off" @change="updateTextWithFormData"></el-input>
          <!-- TODO: type="textarea" -->
        </el-form-item>

        <el-form-item label="Font Size">
          <el-select v-model="textForm.fontSize" @change="updateTextWithFormData" placeholder="Select font size">
            <el-option v-for="size in fontSizes"
              :key="size.value"
              :label="size.label"
              :value="size.value" />
          </el-select>
        </el-form-item>

        <el-form-item label="Font Family">
          <el-select v-model="textForm.fontFamily" @change="updateTextWithFormData" placeholder="Select font face">
            <el-option v-for="font in fontFaces"
              :key="font.value"
              :label="font.label"
              :value="font.value"
              :style="{ fontFamily: font.value }"/>
          </el-select>
        </el-form-item>
      </el-form>

    </collapse-group>

    <span slot="footer" class="dialog-footer">
      <el-button type="danger" @click="onDelete">Delete</el-button>
      <!-- <el-button type="primary" @click="updateTextWithFormData(textForm.textId)">Confirm</el-button> -->
    </span>

    <pre v-if="SHOW_DEBUG">textForm: {{textForm}}</pre>
  </div>
</template>

<script>
import { fontSizes, fontFaces } from "@/components/Modals/availableSettings"

export default {
  props: {
    textId: { required: true },
    textData:  { required: true },
  },
  data: () => ({
    textForm : {
      text: '',
      fontSize: 28,
      fontFamily: 'Arial'
    },
    fontSizes: fontSizes,
    fontFaces: fontFaces,
  }),
  created() {
    this.textForm = {
      text: this.textData.text,
      fontSize: this.textData.fontSize,
      fontFamily: this.textData.fontFamily,
    };

    // this.unwatch = this.$watch('textForm', (v) => {
    //   this.updateTextWithFormData()
    // }, { deep: true })
  },
  // beforeDestroy() {
  //   if ( this.unwatch ) {
  //     this.unwatch()
  //   }
  // },
  methods: {

    updateTextWithFormData() {
      // console.log("updateTextWithFormData");
      // var textIndex = this.getIndexForTextId(textId);
      // this.texts[textIndex].text = this.textForm.text;
      this.$emit('save', { textId: this.textId, ...this.textForm })
    },

    updateAllHeadlinePositions() {
      // this.goals.forEach((_, idx) => {
      //   // update commitment positions
      //   this.goals[idx].headline.y =  this.goals[idx].image.y - this.stageSettings.allHeadlinesFontSize * 1.2;
      //   this.goals[idx].headline.x =  this.goals[idx].image.x;
      // });
    },

    onDelete() {
      this.$emit('delete', { textId: this.textId })
    }
  },
  components: {
  }
}
</script>
